import React from 'react';
import PropTypes from 'react-proptypes';

export default function withShow(Wrapped) {
  return class WithShow extends React.Component {
    static propTypes = {
      show: PropTypes.bool,
    };

    render() {
      // @ts-ignore
      if (!this.props.show) {
        return null;
      }

      return (
        <Wrapped ref={this.bindWrapped} {...this.props} />
      );
    }

    bindWrapped = (node) => {
      // @ts-ignore
      this.wrapped = node;
    };
  };
}
